export const IMAGE_SETTINGS = {
    SAVE_BTN: "save-button",
    CANCEL_BTN: "cancel-button",
    ADD_FIELD_BTN: "add-field-button",
    DELETE_FIELD_BTN: "delete-field-button",
    ADD_IMAGE_MEDIA_BTN: "add-image-media-button",
    STANDARD_CONV_RAD_BTN: "standard-convention-radio-button",
    CUSTOM_CONV_RAD_BTN: "custom-convention-radio-button",
    CUSTOM_TEXT_INPUT: "custom-text-input",
    SELECT_FIELD_TYPES_DRPDWN: "field-types-dropdown",
    FIELD_TYPES: {
        FIELD_TYPE_OPTION: "field-type-option",
        LITERAL_TYPE_OPTION: "literal-type-option",
    },
    SELECT_PRODUCT_FIELD_DRPDWN: "product-field-dropdown",
    PRODUCT_FIELD_OPTION: "product-field-option",
    SEPARATOR_DRPDWN: "separator-dropdown",
    SEPARATOR_OPTION: "separator-option",
    ADMIN_BRDCRMB: "admin-breadcrumb",
    IMAGERY_BRDCRMB: "imagery-breadcrumb",
    PAGE_DESCRIPTION: "page-description",
    NOTIFICATION_ALERT: "notification-alert",
    SEPARATOR_DESCRIPTION: "separator-description",
    CONVENTION_DESCRIPTION: "convention-description",
    SEQUENTIAL_ORDER_DESCRIPTION: "sequential-order-description",
    STANDARD_HINT: "standard-hint",
    STANDARD_HINT_MODAL: "standard-modal-hint",
    CUSTOM_HINT_MODAL: "standard-modal-hint",
    CUSTOM_HINT: "custom-hint",
    PREVIEW_360: "preview-360",
    FORMAT_PREVIEW_BOX: "format-preview-box",
    DRAGGABLE: "draggable",
    ADD_RULESET_BUTTON: "add-ruleset-button",
    SAVE_RULESET_BUTTON: "save-ruleset-button",
    CANCEL_SAVE_RULESET_BUTTON: "cancel-save-ruleset-button",
    RULESET_NAME: "ruleset-name-edit",
    RULESET_DESCRIPTION: "ruleset-description-edit",
    NEW_RULESET_BUTTON: "new-ruleset-button",
    CREATE_RULESET_BUTTON: "create-ruleset-button",
};
